import { z } from 'zod';

export const UrlPreview = z.object({
    title: z.string(),
    previewImageUrl: z.string().nullable(),
});

export type UrlPreview = z.infer<typeof UrlPreview>;
